<div class="modal-header">
  <h4 class="modal-title pull-left">
    Invite Principal
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="doHide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label class="form-label">Email Address<span class="star">*</span></label>
    <input class="form-control" [(ngModel)]="InvitePrincipalModal.EmailId" (change)="onEmailAddressChange();" #EmailId="ngModel" type="text" maxlength="50">
    <p class="redtext" *ngIf="(Validation.IsinValid(InvitePrincipalModal.EmailId) && isSubmit) ||(EmailId.invalid && EmailId.touched)">Email Address is required </p>
    <p class="redtext" *ngIf="(!Validation.IsinValid(InvitePrincipalModal.EmailId) && !Validation.isEmail(InvitePrincipalModal.EmailId) && isSubmit)">Invalid Email Address </p>
  </div>
  <div class="form-group autocomplete-design">
    <label class="form-label">First Name<span class="star">*</span></label>
    <input class="form-control" [(ngModel)]="InvitePrincipalModal.FirstName" #firstname="ngModel" type="text" maxlength="50">
    <p class="redtext" *ngIf="(Validation.IsinValid(InvitePrincipalModal.FirstName) && isSubmit) ||(firstname.invalid && firstname.touched)">First Name is required </p>
  </div>
  <div class="form-group">
    <label class="form-label">Last Name<span class="star">*</span></label>
    <input class="form-control" [(ngModel)]="InvitePrincipalModal.LastName" #lastname="ngModel" type="text" maxlength="50">
    <p class="redtext" *ngIf="(Validation.IsinValid(InvitePrincipalModal.LastName) && isSubmit) ||(lastname.invalid && lastname.touched)">Last Name is required </p>
  </div>
  <div class="form-group">
    <label class="form-label">Phone<span class="red">*</span></label>
    <input class="form-control" #phoneNumberinput="ngModel" required [(ngModel)]="InvitePrincipalModal.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
    <p class="redtext" *ngIf="(Validation.IsinValid(InvitePrincipalModal.PhoneNumber) && isSubmit) ||(phoneNumberinput.invalid && phoneNumberinput.touched)">Phone number is required </p>
  </div>
  <div class="form-group">
    <label class="form-label">Message<span class="star"></span></label>
    <textarea class="form-control" id="txtNotes" [(ngModel)]="InvitePrincipalModal.Notes"></textarea>
  </div>
  <div class="text-right">
    <button class="btn btn-default btn-lg" id="closeModal" (click)="doHide()">Cancel</button>
    <button class="btn btn-success btn-lg" (click)="saveInvitePrincpal();">Invite Principal</button>
    <!--<button class="btn btn-success btn-lg" style="margin-top: 25px" (click)="shareInviteeLink();">Share Link</button>-->
  </div>
</div>
